import type { ChatMessageData } from './chatModel'

// Per-project chat history, DB-backed and keyed by project id (server table project_chat_messages).
// The sidebar chat (ProjectChat) loads the transcript on mount, appends each turn, and polls for new
// messages (including server-generated ones, e.g. an exploration pausing for login). The onboarding
// chat holds its conversation in localStorage until the project exists, then passes it as
// `chat_messages` on createProject (chatMessagesForSeed), which the server seeds into this table — so
// the history carries over the moment the chat moves into the sidebar.

// Strip the onboarding conversation to the wire shape used to seed a freshly-created project's chat
// history (via createProject's `chat_messages`). Drops transport-only hidden turns.
export function chatMessagesForSeed(
  messages: (ChatMessageData & { hidden?: boolean })[],
): { id: string; role: string; content: string; createTime?: string }[] {
  return messages
    .filter((m) => !m.hidden)
    .map(({ id, role, content, createTime }) => ({ id, role, content, createTime }))
}
